export default __webpack_public_path__ + "static/media/logo.5e5dd3a0.png";